module.exports = __webpack_public_path__ + "static/media/icon-wechat.d171fc8c.svg";